import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type {
  CompareObject,
  ComparisonObjectValue,
} from "../../../services/api/instances/comparisonAPI/types";
import {
  createChatComparisonReducerBuilder,
  createComparisonObjectsReducerBuilder,
  deleteComparisonObjectsReducerBuilder,
  getAllComparisonObjectsReducerBuilder,
  getModelsObjectActionReducerBuilder,
  updateComparisonObjectReducerBuilder,
} from "./reducers";
import type { ComparisonServiceState } from "./types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

const initialState: ComparisonServiceState = {
  comparisonObjects: [],
  selectedComparisonObject: null,
  comparisonObjectValue: [],
  models: null,
  isLoading: false,
  isMessageLoading: false,
};

const comparisonSlice = createSlice({
  name: "comparison",
  initialState,
  reducers: {
    setComparisonObjects: (
      state,
      action: PayloadAction<StorageObject<ComparisonObjectValue>[]>,
    ) => {
      state.comparisonObjects = action.payload;
    },
    setSelectedComparisonObject: (
      state,
      action: PayloadAction<StorageObject<ComparisonObjectValue> | null>,
    ) => {
      state.selectedComparisonObject = action.payload;
    },
    setComparisonObjectValue: (
      state,
      action: PayloadAction<CompareObject[]>,
    ) => {
      state.comparisonObjectValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    getAllComparisonObjectsReducerBuilder(builder);
    createComparisonObjectsReducerBuilder(builder);
    updateComparisonObjectReducerBuilder(builder);
    deleteComparisonObjectsReducerBuilder(builder);
    getModelsObjectActionReducerBuilder(builder);
    createChatComparisonReducerBuilder(builder);
  },
});

export const comparisonReducers = comparisonSlice.reducer;
export const {
  setComparisonObjects,
  setSelectedComparisonObject,
  setComparisonObjectValue,
} = comparisonSlice.actions;
